/* Pinflag */

// Añade variante de bolsa al carro --------------------------------------------------------------------------------
function addToCartRecommended(button) {
  const span = button.querySelector(".cart-recommendations-text-button");
  if (span) {
    span.textContent = "AGREGANDO...";
  }
  const cartItem = button.closest(".cart-recommendations-cart-item");

  const variantInput = cartItem.getElementsByClassName(
    "cart-recommendations-form-hidden"
  );
  const variantId = variantInput ? variantInput[0].value : null;

  if (variantId) {
    axios
      .post("/cart/add.js", {
        id: variantId,
        quantity: 1,
      })
      .then((response) => {
        if (span) span.textContent = "AGREGAR AL CARRO";
        const bagMessage = cartItem.querySelector(".cart-recommendations-bag-message");
        if (bagMessage) bagMessage.setAttribute("style", "display: none !important;");
        button.setAttribute("style", "display: none !important;");
        const selectSizeBtn = cartItem.querySelector(".select-size-button");
        if (selectSizeBtn) selectSizeBtn.setAttribute("style", "display: block !important;");
        setTimeout(() => refreshCartDrawer(), 1000);
      })
      .catch((error) => {
        if (span) span.textContent = "AGREGAR AL CARRO";
      });
  }
}

//Actualiza visualmente el carro-----------------------------------------------------------------------------------
function refreshCartDrawer() {
  return fetch("/cart")
    .then((response) => response.text())
    .then((cart) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cart, "text/html");

      const cartItems = doc.querySelector("#cart-items-list");

      if (cartItems) {
        const cartItemList = document.querySelector("#cart-items-list");
        cartItemList.innerHTML = cartItems ? cartItems.innerHTML : "";

        const drawerFooter = doc.querySelector(".drawer__footer");
        const drawerFooterOld = document.querySelector(".drawer__footer");
        drawerFooterOld.innerHTML = drawerFooter ? drawerFooter.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      } else {
        const cartEmpty = doc.querySelector("cart-drawer");
        const cartEmptyOld = document.querySelector("cart-drawer");
        cartEmptyOld.innerHTML = cartEmpty ? cartEmpty.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      }
    })
    .catch((error) => {/* Error updating cart drawer */});
}

(function () {
  function openRecItem(item) {
    const addBtn = item.querySelector(".cart-recommendations-button-add");
    const sizeBtn = item.querySelector(".select-size-button");
    const bagMsg = item.querySelector(".cart-recommendations-bag-message");
    if (addBtn) addBtn.setAttribute("style", "display: block !important;");
    if (sizeBtn) sizeBtn.setAttribute("style", "display: none !important;");
    if (bagMsg) bagMsg.setAttribute("style", "display: block !important;");
  }

  function closeRecItem(item) {
    const addBtn = item.querySelector(".cart-recommendations-button-add");
    const sizeBtn = item.querySelector(".select-size-button");
    const bagMsg = item.querySelector(".cart-recommendations-bag-message");
    if (addBtn) addBtn.setAttribute("style", "display: none !important;");
    if (sizeBtn) sizeBtn.setAttribute("style", "display: block !important;");
    if (bagMsg) bagMsg.setAttribute("style", "display: none !important;");
  }

  document.addEventListener("click", (e) => {
    const sizeBtn = e.target.closest(".select-size-button");
    if (sizeBtn) {
      const item = sizeBtn.closest(".cart-recommendations-cart-item");
      if (!item) return;
      document.querySelectorAll(".cart-recommendations-cart-item").forEach((other) => {
        if (other !== item) closeRecItem(other);
      });
      openRecItem(item);
      return;
    }

    const closeBtn = e.target.closest(".close-variants-buttons-recommended");
    if (closeBtn) {
      const item = closeBtn.closest(".cart-recommendations-cart-item");
      if (item) closeRecItem(item);
    }
  });
})();

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(
    ".card-wrapper .product-form__submit"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const drawerInner = document.querySelector(".drawer__inner");

      if (drawerInner) {
        const hasClasses =
          drawerInner.classList.contains("cart-drawer-pinflag-flex-column") &&
          drawerInner.classList.contains("cart-drawer-pinflag-width");

        if (!hasClasses) {
          drawerInner.classList.add(
            "cart-drawer-pinflag-flex-column",
            "cart-drawer-pinflag-width"
          );
          // Clases agregadas al drawer__inner
        }
      }
    });
  });
});

// Permite estar observando si es necesario extender o no el width del carro -----------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // Prueba
  const cartDrawer = document.querySelector("cart-drawer.drawer");
  const cartRecommendations = document.querySelector("cart-recommendations");

  if (!cartDrawer) {
    // El elemento cartDrawer no se encontró en el DOM
    return;
  }

  if (!cartRecommendations) {
    return;
  }

  function updateCart() {
    // updateCart
    const drawerInner = document.querySelector(".drawer__inner");

    if (!drawerInner) {
      // El elemento drawerInner no se encontró en el DOM
      return;
    }

    if (cartDrawer.classList.contains("is-empty")) {
      // Esta vacio
      drawerInner.style.cssText += "width: 40rem !important;";
    } else {
      drawerInner.style.cssText += "width: 72rem !important;";
      // No esta vacio
    }
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        updateCart();
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });

  updateCart();
});

/* local storage userInformation ---------------------------------------------- */
function formatRut(rut) {
  return rut.replace(/\./g, ""); // Elimina los puntos
}

function checkUserInformation() {
  const storedData = localStorage.getItem("userInformation");

  const userData = JSON.parse(storedData);
  const fullName = userData.names.split(" ");
  const first_name = fullName[0];
  const last_name = fullName.slice(1).join(" ");
  const email = userData.email;
  const rut = formatRut(userData.rut);

  // User information processed

  exponea.update({
    first_name: first_name,
    last_name: last_name,
    rut: rut,
    email: email,
  });

  exponea.identify({
    email_id: email,
  });
}

if (!window.customJsInitialized) {
  window.customJsInitialized = true;
  
  document.addEventListener("DOMContentLoaded", function () {
    // Inicializando tarjetas de producto
    initializeProductCards();
    initializeInfiniteScroll();
    initializeCartDrawer();
  });
}

function initializeProductCards() {
  // Inicializando tarjetas de producto
  const productCards = document.querySelectorAll(".product-card-wrapper");
  productCards.forEach(initializeProductCard);

  if (window.location.pathname.includes("/search")) {
    productCards.forEach((card) => {
      const defaultProductUrl = card.querySelector(".card__heading a")?.href;
      if (defaultProductUrl) {
        const cleanUrl = defaultProductUrl.split("?")[0];
        if (typeof updateVariantSelector === 'function') {
          if (typeof window.debouncedUpdateVariantSelector === 'function') {
            window.debouncedUpdateVariantSelector(card, cleanUrl, true);
          } else {
            updateVariantSelector(card, cleanUrl, true);
          }
        }
      }
    });
  }
}

function initializeProductCard(productCard) {
  const defaultProductUrl = productCard.querySelector(".card__heading a")?.href;
  if (defaultProductUrl) {
    const cleanUrl = defaultProductUrl.split("?")[0];
    // updateVariantSelector se define en color-swatches.liquid
    if (typeof updateVariantSelector === 'function') {
      if (typeof window.debouncedUpdateVariantSelector === 'function') {
        window.debouncedUpdateVariantSelector(productCard, cleanUrl);
      } else {
        updateVariantSelector(productCard, cleanUrl);
      }
    }
  }

  const defaultColorSwatch = productCard.querySelector(
    ".variant_color_swatches.select_variant"
  );
  if (defaultColorSwatch) {
    defaultColorSwatch.classList.add("selected");
    // applySelectedEffect se define en color-swatches.liquid
    if (typeof applySelectedEffect === 'function') {
      applySelectedEffect(defaultColorSwatch);
    }

    const productImage1 = productCard.querySelector(
      ".card__media .product_image_1"
    );
    const productImage2 = productCard.querySelector(
      ".card__media .product_image_2"
    );

    if (productImage1 && productImage2) {
      if (
        productImage2.src.includes("Liquid error") ||
        productImage2.srcset.includes("Liquid error")
      ) {
        productImage2.src = productImage1.src;
        productImage2.srcset = productImage1.srcset;
      }
    }
  }

  productCard.querySelectorAll(".variant_color_swatches").forEach((swatch) => {
    swatch.addEventListener("click", function (e) {
      e.preventDefault();

      if (!this.classList.contains("selected")) {
        // changeProductPLP se define en color-swatches.liquid
        if (typeof changeProductPLP === 'function') {
          if (typeof window.debouncedChangeProductPLP === 'function') {
            window.debouncedChangeProductPLP(this);
          } else {
            changeProductPLP(this);
          }
        }
      }
    });
  });

  const addToCartForm = productCard.querySelector(".product-form");
  if (addToCartForm) {
    addToCartForm.addEventListener("submit", function(event) {
      // handleAddToCart se define en color-swatches.liquid
      if (typeof handleAddToCart === 'function') {
        handleAddToCart(event);
      }
    });
  }
}

function initializeInfiniteScroll() {
  const infiniteScrollElement = document.querySelector("infinite-scroll");
  if (infiniteScrollElement) {
    infiniteScrollElement.addEventListener("productsLoaded", function (event) {
      const newProducts = event.detail.newProducts;
      newProducts.forEach(initializeProductCard);
    });
  }
}

function initializeCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    if (!cartDrawer.open) {
      cartDrawer.open = function () {
        this.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");
      };
    }

    if (!cartDrawer.close) {
      cartDrawer.close = function () {
        this.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      };
    }

    const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", () => cartDrawer.close());
    }
  }
}

function initAccordionMetafields(event) {
  const root = event?.target || document;

  function splitItems(textContent, htmlContent, specsType) {
    const brRegex = /<br\s*\/?>/i;
    if (brRegex.test(htmlContent)) {
      return htmlContent.split(brRegex).filter(Boolean);
    }
    if (textContent.includes('\n')) {
      return textContent.split(/\r?\n/);
    }
    if (textContent.includes('·')) {
      return textContent.split('·').map((item) => item.trim()).filter(Boolean);
    }

    if (specsType === 'composition') {
      const keyValueItems = textContent.split(/\s+(?=[A-Z][a-záéíóúñ]+:)/);
      if (keyValueItems.length > 1) return keyValueItems.map((s) => s.trim()).filter(Boolean);
    }

    const items = [];
    textContent.split(/\s{2,}/).forEach((section) => {
      const s = section.trim();
      if (!s) return;
      let chunks;
      try {
        chunks = s.split(/(?<=\))\s+(?=[A-Z])/);
      } catch (e) {
        chunks = [s];
      }
      chunks.forEach((chunk) => {
        const c = chunk.trim();
        if (!c) return;
        c.split(/\.\s+(?=[A-Z0-9][^\.:]+:)/).forEach((sub) => {
          const item = sub.trim();
          if (item) items.push(item);
        });
      });
    });
    return items.length ? items : [textContent];
  }

  root.querySelectorAll('.product-info-list').forEach((infoList) => {
    const rawContent = infoList.nextElementSibling;
    if (!rawContent || !rawContent.classList.contains('product-raw-content')) return;

    const htmlContent = rawContent.innerHTML.trim();
    const textContent = rawContent.textContent.trim();
    if (!htmlContent && !textContent) return;

    const specsType = infoList.dataset.specsType;
    const items = splitItems(textContent, htmlContent, specsType);
    infoList.innerHTML = '';

    items.forEach((item) => {
      const cleanItem = item.replace(/^-\s*/, '').replace(/\s*-$/, '').trim();
      if (!cleanItem) return;

      const li = document.createElement('li');
      const strippedItem = cleanItem.replace(/^·\s*/, '');
      const colonIndex = strippedItem.indexOf(':');

      if (colonIndex > 0) {
        const key = strippedItem.substring(0, colonIndex);
        const value = strippedItem.substring(colonIndex + 1);
        const strong = document.createElement('strong');
        strong.textContent = key;
        li.appendChild(strong);
        li.appendChild(document.createTextNode(':' + value));
      } else {
        li.textContent = strippedItem;
      }

      infoList.appendChild(li);
    });
  });
}

document.addEventListener('DOMContentLoaded', initAccordionMetafields);
document.addEventListener('shopify:section:load', initAccordionMetafields);

/* Flash sale countdown */
(function () {
  const pad = n => String(n).padStart(2, '0');

  function formatCountdown(ms) {
    if (ms <= 0) return null;
    const days    = Math.floor(ms / 86400000);
    const hours   = Math.floor((ms % 86400000) / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    if (days > 0) return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function updateCountdowns() {
    document.querySelectorAll('[data-expiration]').forEach(el => {
      const expirationTimestamp = parseInt(el.dataset.expiration, 10);
      if (isNaN(expirationTimestamp)) return;
      const expiration = expirationTimestamp * 1000;
      const remaining  = expiration - Date.now();
      const timer      = el.querySelector('.sale-countdown__timer');
      if (!timer) return;
      const formatted  = formatCountdown(remaining);
      if (!formatted) {
        el.style.display = 'none';
      } else {
        timer.textContent = formatted;
      }
    });
  }

  updateCountdowns();
  setInterval(updateCountdowns, 1000);
})();

function cartPromoSlide(button, direction) {
  var wrapper = button.closest('.cart-promo__slider-wrapper');
  if (!wrapper) return;
  var track = wrapper.querySelector('.cart-promo__products');
  if (!track) return;
  var card = track.querySelector('.cart-recommendations-cart-item');
  if (!card) return;
  track.scrollBy({ left: direction * (card.offsetWidth + 8), behavior: 'smooth' });
  setTimeout(function () { cartPromoUpdateArrows(wrapper); }, 350);
}

function cartPromoUpdateArrows(wrapper) {
  var track = wrapper.querySelector('.cart-promo__products');
  var prev  = wrapper.querySelector('.cart-promo__arrow--prev');
  var next  = wrapper.querySelector('.cart-promo__arrow--next');
  if (!track || !prev || !next) return;
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
}

(function () {
  function formatMoney(cents, format) {
    var amount = Math.round(cents / 100);
    return format.replace(/\{\{\s*[\w]+\s*\}\}/g, amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  var _lastPromoTotal = -1;
  var _promoDebounce;

  function updatePromoBar() {
    clearTimeout(_promoDebounce);
    _promoDebounce = setTimeout(doPromoUpdate, 200);
  }

  function doPromoUpdate() {
    var bar = document.querySelector('.cart-promo-bar');
    if (!bar) return;
    var promoMin = parseInt(bar.dataset.promoMin, 10) || 0;
    if (!promoMin) return;
    var moneyFormat = bar.dataset.moneyFormat || '${{amount}}';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price;
        if (total === _lastPromoTotal) return;
        _lastPromoTotal = total;
        var unlocked = total >= promoMin;
        var pct      = unlocked ? 100 : Math.floor(total * 100 / promoMin);
        var fill     = bar.querySelector('.cart-promo-bar__fill');
        var text     = bar.querySelector('.cart-promo-bar__text');
        if (fill) fill.style.width = pct + '%';
        if (!text) return;
        var badge     = bar.dataset.promoBadge || '';
        var badgeHtml = badge ? '&nbsp;<span class="cart-promo-bar__badge">' + badge + '</span>' : '';
        if (unlocked) {
          text.classList.add('cart-promo-bar__text--done');
          var heading   = bar.dataset.promoHeading || '';
          var sep       = (heading && badge) ? ' &mdash; ' : '';
          var badgePart = badge ? '<strong>' + badge + '</strong>' : '';
          text.innerHTML = heading + sep + badgePart + '&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
        } else {
          text.classList.remove('cart-promo-bar__text--done');
          var remaining = promoMin - total;
          var remainingFormatted = formatMoney(remaining, moneyFormat);
          var template = bar.dataset.promoText;
          text.innerHTML = template
            ? template.replace('{amount}', '<strong>' + remainingFormatted + '</strong>') + badgeHtml
            : 'Te faltan <strong>' + remainingFormatted + '</strong> para obtener' + badgeHtml;
        }
      })
      .catch(function () {});
  }

  window._refreshPromoBar = function () {
    _lastPromoTotal = -1;
    updatePromoBar();
  };

  function attachPromoObserver() {
    updatePromoBar();
    var target = document.querySelector('cart-drawer') || document.getElementById('CartDrawer') || document.body;
    new MutationObserver(updatePromoBar).observe(target, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', window._refreshPromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachPromoObserver);
  } else {
    attachPromoObserver();
  }
})();

(function () {
  var FSB_KEY = 'pf_fsb_zone';
  var _fsbDebounce;
  var _lastTotal = null;

  function applyZone(fsb, zone) {
    fsb.setAttribute('data-zone', zone);
  }

  function fsbFormatMoney(cents, format) {
    var amount = Math.round(cents / 100);
    return format.replace(/\{\{\s*[\w]+\s*\}\}/g, amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function renderFSB(fsb, total) {
    var t1 = parseInt(fsb.dataset.threshold1, 10) || 0;
    var t2 = parseInt(fsb.dataset.threshold2, 10) || 0;
    var fillColor             = fsb.dataset.fill || '#121212';
    var doneColor             = fsb.dataset.fillDone || '#2e7d32';
    var textIncomplete        = fsb.dataset.text || '';
    var textDone              = fsb.dataset.textDone || '';
    var moneyFmt              = fsb.dataset.moneyFormat || '';
    var discountEnabled       = fsb.dataset.discountEnabled === 'true';
    var dt                    = parseInt(fsb.dataset.discountThreshold, 10) || 0;
    var discountTextIncomplete = fsb.dataset.discountText || '';
    var discountTextDone      = fsb.dataset.discountTextDone || '';
    var discountTextFinal     = fsb.dataset.discountTextFinal || discountTextDone;
    var tier2Enabled          = fsb.dataset.tier2Enabled === 'true';
    var tier2Threshold        = parseInt(fsb.dataset.tier2Threshold, 10) || 0;
    var tier2TextIncomplete   = fsb.dataset.tier2Text || '';
    var tier2TextDone         = fsb.dataset.tier2TextDone || '';

    var activeZone      = parseInt(fsb.getAttribute('data-zone'), 10) || 1;
    var activeThreshold = activeZone === 1 ? t1 : t2;
    var shippingDone    = activeThreshold > 0 && total >= activeThreshold;
    var discountDone    = discountEnabled && dt > 0 && total >= dt;
    var tier2Done       = tier2Enabled && tier2Threshold > 0 && total >= tier2Threshold;

    var msg, progress, fillClr, remaining;

    if (tier2Done) {
      progress = 100;
      fillClr  = doneColor;
      msg      = tier2TextDone;
    } else if (tier2Enabled && tier2Threshold > 0 && (discountDone || (!discountEnabled && shippingDone))) {
      remaining = Math.max(0, tier2Threshold - total);
      progress  = Math.min(100, Math.floor(total * 100 / tier2Threshold));
      fillClr   = fillColor;
      msg       = tier2TextIncomplete.replace('[amount]', '<strong>' + fsbFormatMoney(remaining, moneyFmt) + '</strong>');
    } else if (discountDone) {
      progress = 100;
      fillClr  = doneColor;
      msg      = discountTextFinal.replace('[amount]', '<strong>' + fsbFormatMoney(0, moneyFmt) + '</strong>');
    } else if (discountEnabled && dt > 0 && shippingDone) {
      remaining = Math.max(0, dt - total);
      progress  = Math.min(100, Math.floor(total * 100 / dt));
      fillClr   = fillColor;
      msg       = discountTextIncomplete.replace('[amount]', '<strong>' + fsbFormatMoney(remaining, moneyFmt) + '</strong>');
    } else if (shippingDone) {
      progress = 100;
      fillClr  = doneColor;
      msg      = textDone;
    } else {
      remaining = activeThreshold > 0 ? Math.max(0, activeThreshold - total) : 0;
      progress  = activeThreshold > 0 ? Math.min(100, Math.floor(total * 100 / activeThreshold)) : 0;
      fillClr   = fillColor;
      msg       = activeThreshold > 0
        ? textIncomplete.replace('[amount]', '<strong>' + fsbFormatMoney(remaining, moneyFmt) + '</strong>')
        : '';
    }

    var msgEl   = fsb.querySelector('.fsb__message');
    var fillEl  = fsb.querySelector('.fsb__fill');
    var trackEl = fsb.querySelector('.fsb__track');

    if (msgEl)   msgEl.innerHTML = msg;
    if (fillEl) {
      fillEl.style.width           = progress + '%';
      fillEl.style.backgroundColor = fillClr;
    }
    if (trackEl) trackEl.setAttribute('aria-valuenow', progress);

    fsb.classList.remove('fsb--loading');
  }

  function updateFSBProgress(delay) {
    clearTimeout(_fsbDebounce);
    _fsbDebounce = setTimeout(function () {
      if (!document.querySelector('.fsb')) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          _lastTotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
          document.querySelectorAll('.fsb').forEach(function (el) { renderFSB(el, _lastTotal); });
        })
        .catch(function () {});
    }, delay != null ? delay : 200);
  }

  function initFSB(fsb) {
    if (fsb._fsbReady) return;
    fsb._fsbReady = true;
    applyZone(fsb, localStorage.getItem(FSB_KEY) || '1');
    var liquidTotal = parseInt(fsb.dataset.cartTotal, 10);
    if (!isNaN(liquidTotal)) _lastTotal = liquidTotal;
    if (_lastTotal !== null) renderFSB(fsb, _lastTotal);
    fsb.querySelectorAll('.fsb__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var z = btn.getAttribute('data-zone');
        localStorage.setItem(FSB_KEY, z);
        document.querySelectorAll('.fsb').forEach(function (el) {
          applyZone(el, z);
          if (_lastTotal !== null) renderFSB(el, _lastTotal);
        });
        updateFSBProgress();
      });
    });
  }

  window._fsbScan = function () { document.querySelectorAll('.fsb').forEach(initFSB); };
  window._updateFSBProgress = updateFSBProgress;

  document.addEventListener('DOMContentLoaded', function () {
    window._fsbScan();
    var obs = new MutationObserver(window._fsbScan);
    document.querySelectorAll('#CartDrawer, .cart__footer').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true });
    });
  });
})();

